import { memo } from "react";
import { Stack, Autocomplete, TextField } from "@mui/material";
import EmployeeMultiSelect from "./EmployeeMultiSelect";

const FiltersToolbar = memo(function FiltersToolbar({
  employeeOptions,
  selectedEmps,
  onEmployeesChange,
  leaveOptions,
  selectedLeaves,
  onLeavesChange,
  timingFilterOptions,
  selectedTimingFilter,
  onTimingFilterChange,
}) {
  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      spacing={1.5}
      alignItems={{ xs: "stretch", lg: "center" }}
    >
      <EmployeeMultiSelect
        employeeOptions={employeeOptions}
        selectedEmps={selectedEmps}
        onChange={onEmployeesChange}
      />

      

      <Autocomplete
        multiple
        size="small"
        options={leaveOptions}
        value={selectedLeaves}
        onChange={(_, v) => onLeavesChange(v)}
        getOptionLabel={(opt) => opt.leavename || ""}
        isOptionEqualToValue={(opt, val) =>
          String(opt.leaveid) === String(val.leaveid)
        }
        sx={{ flex: 1, minWidth: 240 }}
        renderInput={(params) => (
          <TextField {...params} label="Leaves" placeholder="Filter leaves" />
        )}
      />

      <Autocomplete
        size="small"
        options={timingFilterOptions}
        value={selectedTimingFilter}
        onChange={(_, newVal) => onTimingFilterChange(newVal)}
        getOptionLabel={(opt) => opt?.label || ""}
        isOptionEqualToValue={(opt, val) =>
          String(opt.key) === String(val.key)
        }
        sx={{ flex: 1, minWidth: 260 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Attendance timing filter"
            placeholder="Late leaving, early coming..."
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              width: "100%",
            }}
          />
        )}
      />
    </Stack>
  );
});

export default FiltersToolbar;
